<div class="success-dialog">
  <div class="icon-wrapper">
    <i class="bi bi-check-circle-fill"></i>
  </div>

  <h2>
    Link Generated
    <i class="bi bi-rocket-fill text-success"></i>
  </h2>

  <p class="sub-text">Share this link with your candidates.</p>

  <div class="link-box">
    <label>Unique URL</label>

    <div class="url-input">
      <input type="text" [value]="data.url" readonly />

      <button class="copy-icon" (click)="copyLink()">
        <i class="bi bi-clipboard"></i>
      </button>
    </div>

    <div class="text-end">
      <button class="btn-add" type="button" (click)="goToQuizPage()">Done</button>
    </div>
  </div>

  <div class="btn-area">
    <button class="close-btn" (click)="closeDialog()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>
